
export const IS_LOADING = 'IS_LOADING';
export const ERROR = 'ERROR';

export const GET_EVALUABLE_EMPLOYEES_MONITOR = 'GET_EVALUABLE_EMPLOYEES_MONITOR';
